// extracted by mini-css-extract-plugin
module.exports = {"title":"CuratedListing_title__3SD-h"};